import { RequestConfig } from '~/common/services/requests';
import { InceptHeader } from '../../constants/InceptHeader';
import { createHeaders } from '../../logic/createHeaders';
import { DocumentParams } from '../types/DocumentParams';

export const buildHeadersFromDocumentParams = ({
  definition,
  workflow,
  statusDefinition,
}: DocumentParams): RequestConfig['headers'] =>
  createHeaders({
    [InceptHeader.DefinitionName]: definition,
    [InceptHeader.WorkflowName]: workflow,
    [InceptHeader.StatusName]: statusDefinition,
  });
